import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import * as _ from "lodash";
import * as moment from "moment";
import { NgxSpinnerService } from "ngx-spinner";
import { Alert } from "src/app/shared/class/Alert";
import { Pdf } from "src/app/shared/class/Pdf.class";
import { Helper } from "src/app/shared/helpers/helper";
import { QueryParams } from "src/app/shared/models/query-params";
import { User } from "src/app/shared/models/user.model";
import { UserTypePipe } from "src/app/shared/pipe/user-type.pipe";
import { AuthService } from "src/app/shared/services/auth.service";
import { ReportService } from "./../../report.service";

@Component({
  selector: "app-report-access",
  templateUrl: "./report-access.component.html",
  styleUrls: ["./report-access.component.scss"],
})
export class ReportAccessComponent implements OnInit {
  goback = "";

  userLogged: User = {};
  users: User[] = [];

  form: FormGroup;
  startLastAccess = new FormControl();
  minStartLastAccess = new Date();
  strStartLastAccess = "";
  endLastAccess = new FormControl();
  minEndLastAccess = null;
  strEndLastAccess = "";

  constructor(
    private authService: AuthService,
    private reportService: ReportService,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder
  ) {
    this.userLogged = this.authService.getUserLogged();
  }
  async ngOnInit() {
    this.form = new FormGroup({
      startLastAccess: new FormControl("" as string),
      endLastAccess: new FormControl("" as string),
    });
  }

  onChangeStartDate(event) {
    this.strStartLastAccess = Helper.getFormattedBrDate(event.value);
    this.endLastAccess = new FormControl();
    this.minEndLastAccess = new Date(event.value);
    this.strEndLastAccess = "";
    this.form.controls.endLastAccess.setValue("");
    this.form.controls.endLastAccess.updateValueAndValidity();
  }

  onChangeEndDate(event) {
    this.strEndLastAccess = Helper.getFormattedBrDate(event.value);
  }

  clearPeriod() {
    this.strStartLastAccess = "";
    this.form.controls.startLastAccess.setValue("");
    this.form.controls.startLastAccess.updateValueAndValidity();

    this.strEndLastAccess = "";
    this.form.controls.endLastAccess.setValue("");
    this.form.controls.endLastAccess.updateValueAndValidity();
  }

  async onSubmit() {
    if (this.validateForm()) {
      const data: any = await this.reportService.getAccess(
        this.getQueryParams()
      );
      this.users = data;
      this.users.sort((a, b) => (a.lastAccess < b.lastAccess ? -1 : 1));
      console.log(data);
      this.viewPdf();
    } else {
      Alert.warning(Alert.getMessage().errors.requiredFilters);
    }
  }

  getQueryParams() {
    const params: QueryParams[] = [];
    const filters = this.form.controls;

    if (
      !_.isNull(filters.startLastAccess.value) &&
      filters.startLastAccess.value !== ""
    ) {
      params.push({
        id: "startLastAccess",
        value: moment(filters.startLastAccess.value).format("YYYY-MM-DD"),
      });
    }

    if (
      !_.isNull(filters.endLastAccess.value) &&
      filters.endLastAccess.value !== ""
    ) {
      params.push({
        id: "endLastAccess",
        value: moment(filters.endLastAccess.value).format("YYYY-MM-DD"),
      });
    }

    return this.prepareQueryParams(params);
  }

  prepareQueryParams(params: QueryParams[]) {
    let queryParams = "";
    params.map((param) => {
      queryParams = queryParams === "" ? "" : `${queryParams}&`;
      queryParams = `${queryParams}${param.id}=${param.value}`;
    });
    return queryParams;
  }

  validateForm() {
    if (
      this.form.controls.startLastAccess.value !== "" ||
      this.form.controls.endLastAccess.value !== "" ||
      this.form.controls.company.value !== "" ||
      this.form.controls.agent.value !== ""
    ) {
      return true;
    } else {
      return false;
    }
  }

  viewPdf() {
    const pdf = this.makePdf(this.users);
    window.open(URL.createObjectURL(pdf.output("blob")));
  }

  makePdf(users: User[]) {
    // tslint:disable: max-line-length
    const pdf = new Pdf({
      documentTitle: `Relatório Solicitações de Serviço.pdf`,
      header: true,
      footer: true,
    });

    pdf.setFont("times");

    pdf.pullLine(8);

    pdf.writeClauseTitle("RELATÓRIO DE ACESSO");

    pdf.pullLine(10);
    if (users.length > 1) {
      pdf.writeJustifyText({
        text: `(${users.length}) Acessos encontrados`,
      });
    } else {
      pdf.writeJustifyText({
        text: `(${users.length}) Acesso encontrado`,
      });
    }

    pdf.pullLine(10);

    const userTypePipe = new UserTypePipe();
    users.map((user) => {
      pdf.writeJustifyText({
        text: `Nome: ${user.name}`,
      });
      pdf.pullLine(5);
      pdf.writeJustifyText({
        text: `Tipo: ${userTypePipe.transform(user.type)}`,
      });
      pdf.pullLine(5);
      pdf.writeJustifyText({
        text: `Login: ${user.username}`,
      });
      pdf.pullLine(5);
      pdf.writeJustifyText({
        text: `Último Acesso: ${moment(user.lastAccess).format("DD/MM/YYYY")}`,
      });

      pdf.pullLine(8);
      pdf.setLineWidth(0.1);
      pdf.line(10, pdf.getY(), 200, pdf.getY());
      pdf.pullLine(8);
    });

    pdf.pullLine(15);

    return pdf;
  }
}
